export default{
    tableRow:{
        height: 69
    },
};